/**
 * @description 状态管理，如无必要请勿修改
 */
import { isJson } from "@/utils/validate";

const getLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  if (isJson(value)) {
    return JSON.parse(value);
  } else {
    return false;
  }
};

const { lock } = getLocalStorage("lock");

const state = () => ({
  lockscreen: lock,
});

const getters = {
  getLockScreen(state) {
    return state.lockscreen;
  },
};

const mutations = {
  LockScreen(state) {
    // 锁屏
    state.lockscreen = true;
  },
  UnLockScreen(state) {
    // 解锁
    state.lockscreen = false;
  },
};

const actions = {
  LockScreen({ commit, state }) {
    commit("LockScreen");
    localStorage.setItem("lock", `{"lock":true}`);
  },
  UnLockScreen({ commit, state }) {
    commit("UnLockScreen");
    localStorage.setItem("lock", `{"lock":false}`);
  },
};

export default { state, getters, mutations, actions };

// export default {
//   //存储锁屏数据
//   state: {
//     lockscreen: lock,
//   },
//   getters: {
//     getLockScreen(state) {
//       return state.lockscreen;
//     },
//   },
//   //调用方法
//   mutations: {
//     LockScreen(state) {
//       // 锁屏
//       state.lockscreen = true;
//     },
//     UnLockScreen(state) {
//       // 解锁
//       state.lockscreen = false;
//     },
//   },
//   actions: {
//     LockScreen({ commit, state }) {
//       commit("LockScreen");
//       localStorage.setItem("lock", `{"lock":true}`);
//     },
//     UnLockScreen({ commit, state }) {
//       commit("UnLockScreen");
//       localStorage.setItem("lock", `{"lock":false}`);
//     },
//   },
// };
